import React, { useState } from "react";
import Header from "./components/Header";
import ChatBot from "./components/ChatBot";
import Logout from "./components/Logout";
import Sidebar from "./components/Sidebar";
import { Outlet } from "react-router";
import Footer from "./components/Footer";

const Layout = ({ children }) => {
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const [toggleDropdown, setToggleDropdown] = useState(false);
  const [openLogout, setOpenLogout] = useState(false);

  return (
    <div
      style={{
        backgroundColor: "#fae5ff",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "fixed",
          height: "100vh",
          width: "100vw",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            left: "50%",
            top: "0",
            height: "100vh",
            width: "100vw",
            borderRadius: "50%",
            transform: "translateX(-50%) translateY(-50%)",
            backgroundColor: "rgb(203, 108, 230)",
            zIndex: "10",
          }}
        ></div>
        <div
          style={{
            position: "absolute",
            left: "50%",
            top: "0",
            height: "100vh",
            width: "120vw",
            borderRadius: "50%",
            transform: "translateX(-50%) translateY(-45%)",
            backgroundColor: "rgb(220, 143, 241)",
            zIndex: "0",
          }}
        ></div>
      </div>
      <div
        style={{
          maxWidth: "768px",
          margin: "0 auto",
        }}
        onClick={(e) => {
          if (toggleSidebar) {
            setToggleSidebar(false);
          }
          if (toggleDropdown) {
            setToggleDropdown(false);
          }
        }}
      >
        <div
          className="row w-100 mx-auto flex-column align-items-center position-relative"
          style={{
            minHeight: "100vh",
            zIndex: "100",
            // padding: "2px 15px 10px 15px",
            // backgroundColor: '#fae5ff'
          }}
        >
          <div
            className="container-fluid p-0 position-relative"
            style={{
              overflow: "hidden",
              // backgroundColor: "#fae5ff",
              // position:"relative"
            }}
          >
            {toggleSidebar && (
              <div
                style={{
                  position: "relative",
                }}
              >
                <Sidebar toggleSelf={setToggleSidebar} />
              </div>
            )}
            <Header
              toggleSidebar={toggleSidebar}
              setToggleSidebar={setToggleSidebar}
              toggleDropdown={toggleDropdown}
              setToggleDropdown={setToggleDropdown}
              openLogout={openLogout}
              setOpenLogout={setOpenLogout}
            />

            <Logout openLogout={openLogout} setOpenLogout={setOpenLogout} />
            <div>
              {" "}
              {/* Adjust for header height */}
              {/* {children} */}
              <Outlet />
            </div>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Layout;
